// Core
import { useState, useEffect } from 'react';
import { useQuery } from 'react-query';
import {
  Button,
  Box,
  Flex,
  Text,
  useColorModeValue,
} from '@chakra-ui/react';

// Accets
import { apiService } from 'services/ApiService';

// Components
import Card from 'components/Card/Card';
import NotificationsCenterRow from './components/Row';

const Notifications = ({userData}) => {
  const textColor = useColorModeValue('gray.700', '#9FABCB');
  const bg = useColorModeValue('white', '#0A1027');
  const border = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
  const borderBottom = useColorModeValue('1px solid #CBE7FF', '1px solid #262D47');
  const boxShadow = useColorModeValue('unset', '0px 1px 3px 0px rgba(0, 0, 0, 0.10),0px 1px 2px 0px rgba(0, 0, 0, 0.06)');

  const { data, isLoading, refetch } = useQuery({
	    queryKey: ['notificationsCenter'],
	    queryFn: async () => {
	        const response = await apiService.getNotificationCenterOptions();
	        return response.data;
	    },
	    refetchOnWindowFocus: false
  });

  return (
    <Card padding="14px 12px 12px 12px" bg={bg} borderRadius="12px" border={border} boxShadow={boxShadow}>
    	<Flex justifyContent="space-between" pb="14px" borderBottom={borderBottom}>
	    	<Text variant="text-sm" p='0' fontWeight="500" color={textColor}>Type</Text>
	    	<Flex gap="18px">
		    	<Text variant="text-sm" color={textColor} fontWeight="500" p='0'>Push</Text>
		    	<Text variant="text-sm" p='0' fontWeight="500" color={textColor}>Email</Text>
	    	</Flex>
	    </Flex>
	           
	    {!isLoading && data.map((row, index) => {
	      return (
	        <NotificationsCenterRow
	          key={index}
	          title={row.title}
	          type={row.type}
	          email={row.email}
	          push={row.push}
	          refetch={refetch}
	          userData={userData}
	        />
	      );
	    })}
    </Card>
  );
};

export default Notifications;